
















export default {
  name: 'store-links'

  props: ['appStoreUrl', 'playStoreUrl']

  data: ->
    playStore:
      image: require '@/assets/images/lucre-games-google-play-icon.png'
      url: @playStoreUrl

    appStore:
      image: require '@/assets/images/lucre-games-app-store-icon.png'
      url: @appStoreUrl


}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/geotap/StoreLinks.vue